import { useMemo } from 'react';

export const useSvcSubTitle = () => {
  const subTitle = useMemo(() => {
    return [
      {
        revxTypeId: 13,
        typeName: 'Bundling',
        subTitle: ` - Packaging options for your job`,
      },
    ];
  }, []);
  return subTitle;
};
